const steps = [
  {
    selector: '[campaign-tour="filter"]',
    content: "You can filter what campaigns you see",
  },
  {
    selector: '[campaign-tour="box-tiles"]',
    content: "And tiles will give you general information about campaigns",
  },
  {
    selector: '[campaign-tour="datatable-row"]',
    content: "Each row will give you high-level information about a certain campaign, and if you'd like to get more details without leaving the page - click anywhere in the row outside of the name"
  },
  {
    selector: '[campaign-tour="datatable-title"]',
    content: "Now, you can click on the name to navigate to the campaign page",
  }
        
];

export default steps;




